export type PillRect = {
  left: number;
  top: number;
  width: number;
  height: number;
};

export const readActivePill = (container: ParentNode | null): PillRect | null => {
  const button = container?.querySelector<HTMLElement>('button[data-active="true"]');
  return button
    ? {
        left: button.offsetLeft,
        top: button.offsetTop,
        width: button.offsetWidth,
        height: button.offsetHeight,
      }
    : null;
};
